module.exports = __webpack_public_path__ + "img/logo-evn.9281c8db.png";